//import React, { useEffect, useState } from 'react'; //use when virtual reference assistant is enabling
//import React, { useEffect } from 'react'; //use when virtual reference assistant is disabling
import React, { useEffect } from 'react'; 
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Education from './components/Education';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Publications from './components/Publications';
import Projects from './components/Projects';
import Awards from './components/Awards';
import Extracurricular from './components/Extracurricular';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

// ──────────────────────────────────────────────────────────
// 🐼 ScholarScape Virtual Reference Assistant
// To ENABLE  → uncomment the 4 sections marked [ENABLE]
// To DISABLE → keep commented (current state)
// ──────────────────────────────────────────────────────────

// [ENABLE 1/4] → uncomment below line to enable widget import
// import ScholarScapeWidget from './ScholarScapeWidget';

function App() {

  // [ENABLE 2/4] → uncomment below line to enable widget state
  // const [showWidget, setShowWidget] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 120,
    });
    // IMPORTANT FIX – refresh AOS when images/sections load
    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Rajeevan M S",
    "url": "https://msrajeevan.in"
  };

  return (
    <div className="App font-sans bg-white text-gray-800">
      <Helmet>
        <title>M. S. RAJEEVAN | Researcher</title>
        <meta name="description" content="Official website of M S Rajeevan — Researcher and Developer. Explore profile, publications, projects, and more." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <Navbar />
      <section id="hero">
        <Hero />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="education">
        <Education />
      </section>
      <section id="experience">
        <Experience />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="publications">
        <Publications />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="awards">
        <Awards />
      </section>
      <section id="extracurricular">
        <Extracurricular />
      </section>
      <section id="gallery">
        <Gallery />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <Footer />

      {/* [ENABLE 3/4] → uncomment below block to show toggle button */}
      {/*
      <button
        onClick={() => setShowWidget(!showWidget)}
        style={{
          position:     'fixed',
          bottom:       '24px',
          left:         '24px',
          background:   'linear-gradient(135deg, #1e3a5f, #2563eb)',
          color:        '#fff',
          border:       'none',
          borderRadius: '50px',
          padding:      '12px 20px',
          fontSize:     '0.85rem',
          fontWeight:   '600',
          cursor:       'pointer',
          zIndex:       99999,
          boxShadow:    '0 4px 16px rgba(37,99,235,0.4)',
          display:      'flex',
          alignItems:   'center',
          gap:          '8px',
          fontFamily:   'Inter, sans-serif',
        }}
      >
        {showWidget ? '✕ Hide Assistant' : '🐼 Library Assistant'}
      </button>
      */}

      {/* [ENABLE 4/4] → uncomment below line to show widget */}
      {/* {showWidget && <ScholarScapeWidget />} */}

    </div>
  );
}

export default App;
